const ThankYou = () => import("./pages/ThankYou.vue");
const UserDetails = () => import("./pages/UserDetails.vue");

export const IndixitalRoutes = [
  {
    path: "/club-mahindra",
    component: UserDetails,
    meta: {
      title: "Club Mahindra Holidays"
    }
  },
  {
    path: "/club-mahindra/thankyou",
    component: ThankYou
  }
];
